import { FC } from 'react';
import { Field, FieldProps, FormikProps, FormikValues } from 'formik';
// @ts-ignore
import { RadioGroup } from 'react-radio-buttons';
import { AlertComponent, Box, Button, FieldRow, Flatfile, Flex, Modal, RadioButton } from '..';
import { flatfilePeopleValidator } from '../../../utils';

import { FieldType as FlatFileFieldType } from '../../../consts/flatfileFields';
import { Option } from '../../../utils/types';
import { Label } from '../../../typography';

interface Props {
  addStakeholderToOrganisation?: boolean;
  setShowUploadModal: (value: boolean) => void;
  showPeopleOptionsModal: boolean;
  setShowPeopleOptionsModal: (value: boolean) => void;
  showUploadModal: boolean;
  isAdminPortal: boolean;
  formikProps: FormikProps<FormikValues>;
}

type FormType = {
  ministryId: Option | undefined;
  typeId: Option | undefined;
  uploadData: any;
  fields: FlatFileFieldType[];
  updateOrNew: string;
};

const UploadInstitutionsPeopleModal: FC<Props> = props => {
  return (
    <Modal
      open={props.showUploadModal}
      onClose={() => props.setShowUploadModal(!props.showUploadModal)}
      heading="Upload Data"
      bodyOverflowVisible={true}
      width={'1000px'}
    >
      <Flex direction="column" size="1" px={3}>
        <Flex direction="column" size="1" flexWrap="nowrap" justify="space-around" minHeight={170}>
          <FieldRow>
            <FieldRow flex={0.5}>
              <Field
                name="updateOrNew"
                render={({ field }: FieldProps<FormType>) => (
                  <Box {...props.formikProps} flexDirection={'column'}>
                    <Label htmlFor="updateOrNew">Select option:</Label>
                    <RadioGroup
                      value={props.formikProps.values.updateOrNew}
                      onChange={(value: string) => {
                        props.formikProps.setFieldValue('updateOrNew', value);
                      }}
                      horizontal={true}
                    >
                      <RadioButton value="new">New</RadioButton>
                      <RadioButton value="update">Update</RadioButton>
                    </RadioGroup>
                  </Box>
                )}
              />
            </FieldRow>
          </FieldRow>
          <FieldRow>
            <AlertComponent
              title={`Instructions`}
              message={`
                    Please upload a maximum of 1500 records at a time

                    Note that CSV values are sensitive to:
                      - Typographical errors
                      - Text Case
                      - Naming conventions
                  `}
            />
          </FieldRow>
        </Flex>
        {/* flatfile buttons */}
        <FieldRow>
          <Flex direction="row" size="1" flexWrap="nowrap" justify="space-between">
            <Field
              name="uploadData"
              render={({ field }: FieldProps<FormType>) => {
                return (
                  <Flatfile
                    csvFileData={undefined}
                    hideDownloadButton={true}
                    csvFileName={`${props.formikProps.values.typeId &&
                      props.formikProps.values.typeId.label}StakeholdersTemplate.csv`}
                    flatFileDataType="People"
                    flatFileFields={props.formikProps.values.fields}
                    flatFileSubmitHandler={async (results: any) => {
                      // check total number of entries
                      if (results.length > 1500) {
                        throw new Error('Client error - Please only upload a maximum of 1500 stakeholders at a time');
                      }

                      props.formikProps.values.uploadData = results;

                      return props.formikProps.handleSubmit();
                    }}
                    flatFileValidators={(record: any) =>
                      flatfilePeopleValidator(record, props.formikProps.values.updateOrNew)
                    }
                    close={() => props.setShowUploadModal(!props.showUploadModal)}
                  />
                );
              }}
            />
            <Button
              onClick={() => props.setShowPeopleOptionsModal(!props.showPeopleOptionsModal)}
              text="Template"
              type="button"
              bg="warning"
              p={0}
              width="40px"
            />
          </Flex>
        </FieldRow>
      </Flex>
    </Modal>
  );
};

export default UploadInstitutionsPeopleModal;
